var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRightCaret = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.121,
    height: 13.414,
    viewBox: "0 0 8.121 13.414",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.707 0.707)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "rightcaret",
    d: "M0,0,6,6l6-6",
    transform: "translate(0 12) rotate(-90)",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: "2px"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRightCaret);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/right-caret.ff693cd35e3b0255e439b557ab9d6dcf.svg";